var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.groupByFamilyStyle
    ? _c(
        "div",
        _vm._l(_vm.groups, function (iconGroup) {
          return _c("div", { key: `${iconGroup.family}-${iconGroup.style}` }, [
            _c(
              "h3",
              {
                staticClass: "h5 text-uppercase margin-y-2xl",
                staticStyle: {
                  "letter-spacing": "var(--letter-spacing-2xl)",
                  "--headings-font-weight": "var(--font-weight-black)",
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.sectionHeader(iconGroup.family, iconGroup.style)
                    ) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.groupCssClasses },
              [
                _vm._l(iconGroup.icons.slice(0, _vm.maxIcons), function (icon) {
                  return _c("icon", {
                    key: icon.objectID,
                    attrs: {
                      icon: icon,
                      "icon-style": icon.style,
                      "selected-icon-id": _vm.selectedIconId,
                      "selected-family": _vm.selectedFamily,
                      "selected-style": _vm.selectedStyle,
                      "is-pro-user": _vm.isProUser,
                      "results-view": _vm.resultsView,
                      version: _vm.version,
                    },
                    on: { toggleIcon: _vm.toggleIcon },
                  })
                }),
                _vm._v(" "),
                iconGroup.icons.length >= _vm.maxIcons
                  ? _c("view-more", {
                      attrs: {
                        "selected-family": iconGroup.family,
                        "selected-style": iconGroup.style,
                        "has-search-term": _vm.hasSearchTerm,
                      },
                      on: {
                        viewMore: function ($event) {
                          return _vm.$emit("viewMore", $event)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ])
        }),
        0
      )
    : _c(
        "div",
        { class: _vm.groupCssClasses },
        _vm._l(_vm.icons, function (icon) {
          return _c("icon", {
            key: icon.objectID,
            attrs: {
              icon: icon,
              "icon-style": icon.style,
              "selected-icon-id": _vm.selectedIconId,
              "selected-family": _vm.selectedFamily,
              "selected-style": _vm.selectedStyle,
              "is-pro-user": _vm.isProUser,
              "results-view": _vm.resultsView,
              version: _vm.version,
            },
            on: { toggleIcon: _vm.toggleIcon },
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }